import { isRouteErrorResponse, useRouteError } from 'react-router';
import NotFound, { ErrorType } from '@/pages/notFound/NotFound.tsx';

const RootErrorBoundary = () => {
  // TODO errorHandling: customise error page
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    const errorType =
      error.status % 100 === 4 ? ErrorType.NOT_FOUND : ErrorType.ERROR;

    return <NotFound errorType={errorType} />;
  } else if (error instanceof Error) {
    return (
      <div>
        <h1>Error</h1>
        <p>{error.message}</p>
      </div>
    );
  } else {
    return <h1>Unknown Error</h1>;
  }
};

export default RootErrorBoundary;
